import { BadgeType } from '@appliedsystems/applied-design-system';
import { TransactionType } from '@appliedsystems/payments-core';
import React from 'react';
import { usePaymentsTranslation } from '../../../hooks/usePaymentsTranslation';
import { useHppDataStore } from '../../HostedPaymentPageContainer/useHppData';
import { PolicySummary } from '../PolicySummary/PolicySummary';

type PolicySummaryListProps = {
  isConfirmationPage: boolean;
};

export const PolicySummaryList = ({ isConfirmationPage }: PolicySummaryListProps) => {
  const { hppData } = useHppDataStore();
  const { financedPolicyDetails, nonFinancedPolicyDetails } = hppData.pf?.quote || {};
  const { t } = usePaymentsTranslation();
  const isPaidWithPF = Boolean(
    hppData.paymentOption === TransactionType.PREMIUM_FINANCE && hppData?.pf?.quote?.quoteId,
  );
  const showPill = (isConfirmationPage && isPaidWithPF) || !isConfirmationPage;

  return (
    <div>
      {financedPolicyDetails &&
        financedPolicyDetails.map((policy) => (
          <PolicySummary
            key={policy.policyNumber}
            policy={policy}
            showPill={showPill}
            badgeType={BadgeType.Accordion}
            badgeText={t('FINANCING_AVAILABLE')}
            badgeIcon={undefined}
            badgeTestId={undefined}
          />
        ))}
      {nonFinancedPolicyDetails &&
        nonFinancedPolicyDetails.map((policy) => (
          <PolicySummary
            key={policy.policyNumber}
            policy={policy}
            showPill={showPill}
            badgeType={BadgeType.Applied}
            badgeText={t('DUE_IN_FULL')}
            badgeIcon={'NoIcon'}
            badgeTestId={'due-in-full-badge'}
          />
        ))}
    </div>
  );
};
